import * as React from 'react';
// the 3 imports below are necessary to support AbortController for IE11
// tslint:disable-next-line:no-submodule-imports
import 'promise-polyfill/src/polyfill';
// tslint:disable-next-line:no-submodule-imports
import { Button, Container, Accordion, Loader, DropdownItemProps } from 'semantic-ui-react';
import './webform.less';
import { autobind } from 'core-decorators';
import { STATUS, IState } from '../../interfaces/state';
import values from 'lodash/values';
import find from 'lodash/find';
import isNil from 'lodash/isNil';
import Recaptcha from 'react-recaptcha';
import {
  FormBuilder, ITxItemProfileValue, ITab, ITabField,
  ITableItem, USER_LINK_TYPE, IFieldValueObject,
  ConditionalUtils, MainHeader, IExternalIncidentParams, RESOURCE_FIELD_TYPE,
  IPickListItem, getPageDropdownOptions, getResourceAndTypeParamsByTypeId,
  IPagedTaxonomyElementsResponse, TaxonomyApi, getInitSearchedOptionsTaxonomy,
  IPagedLibraryElementsResponse, LIBRARY_TYPE, LibraryApi,
  getPageLibraryDropdownOptions, getInitSearchedOptionsLibrary,
  IPagedSearchDropdownResults, RESOURCE_TYPE, IMappedRefTaxFieldValue,
  TAXONOMY_RESOURCE_API, RESOURCE_TYPE_TO_TAXONOMY_RESOURCE_API,
  ITaxonomyDataForEventFieldWithEventTypeIdParams, SUGGESTABLE_FIELD_TYPE_TITLES, LmxSuggestionsModal,
  IUserElement,
} from '@logicmanager/common';
import { TabContainer } from '../../containers/tab-container';
import { WEBFORM_TEXT, TEMP_INCIDENT_ID } from '../../constants';
import * as BUILD from '../../../config/config';
import { Header } from '../header';
import { DATA_TEST_ID } from '../data-test-id';

export class WebformView extends React.Component<any, IWebformViewState> {
  private RESET_FIELD_STRING: string = '';
  public abortController: AbortController = new AbortController();
  constructor(props: any) {
    super(props);
    this.state = {
      isLmxSuggestionsOpen: false,
      referencedResourceType: null,
      targetSuggestionField: null
    };
  }

  public componentWillUnmount(): void {
    URL.revokeObjectURL(this.props.ui.logoUrl);
  }

  @autobind
  public getStoreValues(store: IState): { [key: number]: ITxItemProfileValue } {
    return store.values.fields;
  }

  private isFieldIncomplete(id: string, value: string): boolean {
    return this.props.meta.fields[id] && this.props.meta.fields[id].required
      && this.isFieldEmpty(this.props.meta.fields[id], value);
  }

  private isFieldEmpty(field: ITabField, value: string): boolean {
    return !value || (field && field.fieldType === RESOURCE_FIELD_TYPE.PICK_LIST && !!value && value === '-5000');
  }

  @autobind
  public onChange(id: string, value: IFieldValueObject): void {
    if (this.props.meta.fields[id]) {
      const previousValue: string = this.props.values.fields[id] ? this.props.values.fields[id].value : '';
      const incomplete: boolean = this.isFieldIncomplete(id, value.value);
      const newValue: IFieldValueObject = {
        ...value,
        incomplete
      };
      this.props.updateValue(id, newValue);
      if (this.props.meta.fields[id].isConditional) {
        ConditionalUtils.handleConditionalUpdate(previousValue, value.value,
                                                 this.props.updateValue, this.props.meta.fields[id],
                                                 null, this.props.addField);
      }
    }
  }

  @autobind
  public onChangeTableField(id: string, tableItems: ITableItem[]): void {
    this.props.updateTableValues(id, tableItems);
  }

  @autobind
  public onChangeUser(id: string, value: string, linkType: USER_LINK_TYPE): void {
    const incomplete: boolean = this.isFieldIncomplete(id, value);
    this.props.updateValue(id, {
      value,
      incomplete,
      valid: true
    });
    this.props.updateLinkType(id, linkType);
  }

  @autobind
  public onBlur(id: string, value: string): void {
    this.props.updateValue(id, {
      incomplete: this.isFieldIncomplete(id, value)
    });
  }

  @autobind
  public getTabsAsSortedArray(tabs: ITab[] | {[tabId: string]: ITab}): ITab[] {
    return values(tabs)
      .filter((a: ITab): boolean => a.visible)
      .sort((a: ITab, b: ITab): number => a.sequence - b.sequence);
  }

  @autobind
  public getFieldsFromIds(fields: number[]): ITabField[] {
    const tabFields: ITabField[] = [];
    fields.forEach((fieldId: number) => {
      let filteredTabField: ITabField = this.props.meta.fields[fieldId];
      if (filteredTabField.title === 'Reported Type' && filteredTabField.predefined
            && filteredTabField.choiceItems && !this.props.isExternal) {
        filteredTabField = {
          ...filteredTabField,
          choiceItems: filteredTabField.choiceItems.filter((choice: IPickListItem) => choice.id !== 2)
        };
      }
      tabFields.push(filteredTabField);
    });
    return tabFields;
  }

  @autobind
  public cancelTemplateFile(id: string): void {
    this.props.updateValue(id, {
      value: this.RESET_FIELD_STRING,
      valid: true,
      extra: this.RESET_FIELD_STRING
    });
  }

  @autobind
  public cancelTemplateFiles(id: string, value: string, extra: string): void {
    if (this.props.cancelTemplateFiles) {
      this.props.cancelTemplateFiles(id, value, extra);
    } else {
      this.props.updateValue(id, {
        value,
        valid: true,
        extra
      });
    }
  }

  @autobind
  public onCreateExternalUser(newUsers: IUserElement[]): void {
    this.props.addUsers(newUsers);
  }

  @autobind
  public getTabContent(tab: ITab): JSX.Element {
    return (
      <FormBuilder
        showLabel
        showDataCard
        metaList={this.getFieldsFromIds(tab.fields as number[])}
        states={this.props.meta.states}
        countries={this.props.meta.countries}
        users={this.props.meta.users}
        getStoreValues={this.getStoreValues}
        onChange={this.onChange}
        onBlur={this.onBlur}
        saveTemplateFile={this.props.saveTemplateFile}
        saveTemplateFiles={this.props.saveTemplateFiles}
        downloadFile={this.props.downloadFile}
        cancelTemplateFile={this.cancelTemplateFile}
        cancelTemplateMultiFile={this.cancelTemplateFiles}
        onChangeTableField={this.onChangeTableField}
        onChangeUser={this.onChangeUser}
        getSearchOptions={this.getSearchOptions}
        getInitSearchedOptionsLibrary={this.getInitSearchedOptionsLibrary}
        getInitSearchedOptionsTaxonomy={this.getInitSearchedOptionsTaxonomy}
        onOpenLmxSuggestionsModal={this.onOpenLmxSuggestionsModal}
        onCloseLmxSuggestionsModal={this.onCloseLmxSuggestionsModal}
        fetchTaxonomyCardData={!!this.props.internal
          ? this.fetchTaxonomyCardDataInternal : this.fetchTaxonomyCardDataExternal}
        getGroupUsers={this.props.groupUsers}
        onCreateExternalUser={!this.props.isExternal ? this.onCreateExternalUser : null}
      />
    );
  }

  @autobind
  public onCreateReferencesFromSuggestions(checkedMap: {[id: number]: boolean}): void {
    const id: string = this.state.targetSuggestionField.id;
    const checkedIds: string[] = [];
    Object.entries(checkedMap).forEach(([suggestionId, isChecked]: [string, boolean]) => {
      if (isChecked) {
        checkedIds.push(`${suggestionId}`);
      }
    });
    this.onChange(id, {value: checkedIds.toString(), valid: true});
  }

  @autobind
  private onOpenLmxSuggestionsModal(referencedResourceType: number, suggestionsInput: ITabField): void {
    this.setState({
      isLmxSuggestionsOpen: true,
      referencedResourceType,
      targetSuggestionField: suggestionsInput
    });
  }

  @autobind
  private onCloseLmxSuggestionsModal(): void {
    this.setState({
      isLmxSuggestionsOpen: false,
      targetSuggestionField: null
    });
  }
  @autobind
  private getLmxSuggestionsModal(): JSX.Element {
    const suggestionsInput: ITabField[] = !isNil(this.props.values) && !isNil(this.props.values.fields)
      ? Object.values(this.props.values.fields).filter((filterValue: IFieldValueObject) => {
        if (filterValue.fieldType === RESOURCE_FIELD_TYPE.PICK_LIST
          || filterValue.fieldType === RESOURCE_FIELD_TYPE.MULTI_SELECT_LIST) {
          const metaField: ITabField = !isNil(this.props.meta.fields) ? this.props.meta.fields[filterValue.id] : null;
          return !isNil(metaField) && !metaField.hasOwnProperty('referenceEntity');
        }
        return !isNil(SUGGESTABLE_FIELD_TYPE_TITLES[filterValue.fieldType]);
      }).map((value: IFieldValueObject) => {
        const hasFieldMeta: boolean = !isNil(this.props.meta) && !isNil(this.props.meta.fields)
          && !isNil(this.props.meta.fields[value.id]);
        const hasTitle: boolean = hasFieldMeta && !isNil(this.props.meta.fields[value.id].title);
        const hasTableItems: boolean = hasFieldMeta && !isNil(this.props.meta.fields[value.id].tableItems);
        const hasTabId: boolean = hasFieldMeta && !isNil(this.props.meta.fields[value.id].tabId);
        const hasId: boolean = hasFieldMeta && !isNil(this.props.meta.fields[value.id].id);
        const hasChoiceItems: boolean = hasFieldMeta && !isNil(this.props.meta.fields[value.id].choiceItems);
        return {
          ...value,
          title: hasTitle ? this.props.meta.fields[value.id].title : '',
          tableItems: hasTableItems ? this.props.meta.fields[value.id].tableItems : [],
          tabId: hasTabId ? this.props.meta.fields[value.id].tabId : '',
          id: hasId ? this.props.meta.fields[value.id].id : '',
          fieldType: value.fieldType as RESOURCE_FIELD_TYPE,
          choiceItems: hasChoiceItems ? this.props.meta.fields[value.id].choiceItems : []
        };
      }) : [];
    const isSSL: boolean = !isNil(this.state.targetSuggestionField)
      && this.state.targetSuggestionField.fieldType === RESOURCE_FIELD_TYPE.PICK_LIST;
    return (
      <LmxSuggestionsModal
        isOpen={this.state.isLmxSuggestionsOpen}
        referencedResourceType={this.state.referencedResourceType}
        onCloseLmxSuggestionsModal={this.onCloseLmxSuggestionsModal}
        taskName={this.props.taskName}
        incidentId={TEMP_INCIDENT_ID}
        suggestionsInput={suggestionsInput}
        users={this.props.meta.groupUsers}
        isSSL={isSSL}
        isExternal={!!this.props.isExternal}
        onCreateReferencesFromSuggestions={this.onCreateReferencesFromSuggestions}
      />
    );
  }

  @autobind
  public getFormTabs(): JSX.Element[] {
    return this.getTabsAsSortedArray(this.props.meta.tabs).map((tab: ITab) => {
      if (!find(this.props.values.fields, { tabId: tab.id, visible: true }) || this.state.isLmxSuggestionsOpen) {
        return;
      }
      return (
        <TabContainer
          key={tab.id}
          id={tab.id}
          title={tab.title}
          content={this.getTabContent(tab)}
        />
      );
    });
  }

  public componentDidUpdate(prevProps: any): void {
    if (!this.props.ui.isFetching && this.props.ui.status === STATUS.Failure) {
      this.props.history.push('/error');
    }
  }

  @autobind
  public getInitSearchedOptionsTaxonomy(elementIds: string,
                                        fieldId?: string,
                                        typeId?: number
  ): Promise<DropdownItemProps[]> {
    const externalIncidentParams: IExternalIncidentParams = this.props.internal
      ? null
      : this.props.params;
    return getInitSearchedOptionsTaxonomy(elementIds, fieldId, typeId, externalIncidentParams);
  }

  @autobind
  public getInitSearchedOptionsLibrary(indicatorIds: number[]): Promise<DropdownItemProps[]> {
    const externalIncidentParams: IExternalIncidentParams = this.props.internal
      ? null
      : this.props.params;
    return getInitSearchedOptionsLibrary(indicatorIds, externalIncidentParams);
  }

  @autobind
  private abortPriorApiRequest(): void {
    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();
  }

  @autobind
  public async getSearchOptions(searchQuery: string,
                                offset: number,
                                fieldId?: string,
                                taxonomyTypeId?: number,
                                level?: number,
                                libraryType?: LIBRARY_TYPE,
                                status?: string,
                                limit?: number,
                                ancestorId?: number,
  ): Promise<IPagedSearchDropdownResults> {
    this.abortPriorApiRequest();
    const { signal } = this.abortController;
    const externalIncidentParams: IExternalIncidentParams = this.props.internal
      ? null
      : this.props.params;

    if (!!taxonomyTypeId) {
      const pagedElements: IPagedTaxonomyElementsResponse = await TaxonomyApi.pagedSearchElementsByName({
        ...getResourceAndTypeParamsByTypeId(taxonomyTypeId),
        name: searchQuery,
        includeParents: false,
        page: offset,
        level,
        ancestorId,
        resourceFieldId: fieldId,
        ...externalIncidentParams
      }, [], signal).request();
      return getPageDropdownOptions(pagedElements, true);
    } else {
      const pagedElements: IPagedLibraryElementsResponse = await LibraryApi.pagedLibraryIndicatorsByName({
        type: libraryType,
        status,
        name: searchQuery,
        offset,
        limit,
        ...externalIncidentParams
      }, signal).request();
      return getPageLibraryDropdownOptions(pagedElements, true);
    }
  }

  @autobind
  public getRecaptcha(): JSX.Element {
    if (!this.props.ui.isCaptchaEnabled) {
      return null;
    }
    return (
      <div className="form-captcha" data-test-id={DATA_TEST_ID.WEBFORM_CAPTCHA}>
        <label>{WEBFORM_TEXT.CAPTCHA_LABEL}</label>
        <Recaptcha
          sitekey={BUILD.RECAPTCHA_SITE_KEY}
          verifyCallback={this.props.handleCaptchaVerify}
          expiredCallback={this.props.handleCaptchaExpiration}
        />
      </div>
    );
  }

  @autobind
  public getWebform(): JSX.Element {
    if (this.props.ui.isFetching) {
      return (
        <div>
          <Loader className="loader" active inverted={this.props.modal} />
        </div>
      );
    }

    const formTitle: string = this.props.formTitle || WEBFORM_TEXT.DEFAULT_INCIDENT_NAME;
    return (
      <div data-test-id={this.props.formTitle}>
        <Container
          className="webform-view-container"
          data-test-id={DATA_TEST_ID.WEBFORM_CONTAINER}
          fluid={this.props.internal}
        >
          {!this.props.internal && <MainHeader heading={formTitle} childrenPosition="end"/>}
          <h4>{WEBFORM_TEXT.FORM_INSTRUCTION}</h4>
          <Accordion
            exclusive={false}
            fluid
            data-test-id={DATA_TEST_ID.WEBFORM_ACCORDION}
          >
            {this.getFormTabs()}
          </Accordion>
          {this.getRecaptcha()}
          <Button
            className="submit-btn"
            size="large"
            primary
            fluid
            onClick={this.props.handleSubmit}
            data-test-id={DATA_TEST_ID.WEBFORM_SUBMIT_BUTTON}
          >
            {WEBFORM_TEXT.SUBMIT}
          </Button>
        </Container>
      </div>
    );
  }

  @autobind
  public async fetchTaxonomyCardDataExternal(referenceEntity: RESOURCE_TYPE,
                                             taxonomyElementId: number,
                                             eventFieldId: number): Promise<IMappedRefTaxFieldValue[]> {
    this.abortPriorApiRequest();
    const resource: TAXONOMY_RESOURCE_API = RESOURCE_TYPE_TO_TAXONOMY_RESOURCE_API[referenceEntity] || null;
    if (!resource) {
      return null;
    }
    const { signal } = this.abortController;
    const externalIncidentParams: IExternalIncidentParams = this.props.internal
      ? null
      : this.props.params;
    const params: ITaxonomyDataForEventFieldWithEventTypeIdParams = {
      resource,
      id: taxonomyElementId,
      eventTypeId: this.props.params.test,
      eventFieldId,
      ...externalIncidentParams
    };
    return TaxonomyApi.getTaxElementDataByEventFieldIdWithEventTypeIdExternal(params, signal).request();
  }

  @autobind
  public async fetchTaxonomyCardDataInternal(referenceEntity: RESOURCE_TYPE,
                                             taxonomyElementId: number,
                                             eventFieldId: number): Promise<IMappedRefTaxFieldValue[]> {
    this.abortPriorApiRequest();
    const resource: TAXONOMY_RESOURCE_API = RESOURCE_TYPE_TO_TAXONOMY_RESOURCE_API[referenceEntity] || null;
    if (!resource) {
      return null;
    }

    const params: any = {
      resource,
      id: taxonomyElementId,
      eventTypeId: this.props.testId,
      eventTypeFieldId: eventFieldId
    };

    return TaxonomyApi.getTaxElementDataByEventFieldIdWithEventTypeId(params).request();
  }

  public render(): JSX.Element {
    return (
      <React.Fragment>
        {!this.props.internal && <Header logoUrl={this.props.ui.logoUrl} />}
        {this.getWebform()}
        {this.getLmxSuggestionsModal()}
      </React.Fragment>
    );
  }
}

interface IWebformViewState {
  readonly isLmxSuggestionsOpen: boolean;
  readonly referencedResourceType?: number;
  readonly targetSuggestionField: ITabField;
}
